import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthStore } from '@features/auth/auth.store';
import { AppPaths } from '@core/routes/app-paths';
import {
  hasFleetAndTeamAccess,
  hasJobsAccess,
  hasMarketplaceAccess,
  hasWorkSessionsReviewAccess,
  isPlatformStaffUser,
} from '@core/utils/role.utils';

/**
 * Restricts Marketplace to trucking companies (trucking_owner, trucking_dispatcher, mto_ceo) or trucking companyType.
 * Platform admin without a trucking role cannot access; contractors use Jobs instead.
 */
export const marketplaceAccessGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const user = authStore.user();
  const payload = {
    primaryRole: user?.primaryRole,
    roles: user?.roles,
    companyType: user?.companyType,
  };
  const hasAccess = hasMarketplaceAccess(payload);

  if (hasAccess) {
    return true;
  }

  if (hasJobsAccess(payload)) {
    return router.createUrlTree([AppPaths.JOBS]);
  }
  if (hasFleetAndTeamAccess(payload)) {
    return router.createUrlTree([AppPaths.FLEET]);
  }
  if (hasWorkSessionsReviewAccess(payload)) {
    return router.createUrlTree([AppPaths.WORK_SESSIONS]);
  }
  if (isPlatformStaffUser(payload)) {
    return router.createUrlTree([AppPaths.ADMIN.ROOT, AppPaths.ADMIN.COMPANY_MANAGEMENT]);
  }
  return router.createUrlTree([AppPaths.PROFILE]);
};
